/**
 * 简易的全局存储
 */
const store = {}

export default {
    setValue(key, value) {
        store[key] = value
    },
    getValue(key) {
        return store[key]
    }
}
